import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface IFRSQuestionDTO {
  id: string;
  status: string;
  description: string | null;
  marks: number | null;
  requirements: string | null;
}

export interface IFRSQuestionsMetaDTO {
  total: number;
  page: number;
  lastPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetIFRSQuestionsResponse {
  data: IFRSQuestionDTO[];
  meta: IFRSQuestionsMetaDTO;
}

interface GetIFRSQuestionsParams {
  page?: number;
  limit?: number;
  sort?: "asc" | "desc";
}

type GetIFRSQuestionsAPIResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: GetIFRSQuestionsResponse;
};

export const GetIFRSQuestions = async (
  ifrsId: string,
  {
    page = 1,
    limit = 10,
    sort = "asc",
  }: GetIFRSQuestionsParams = {}
): Promise<GetIFRSQuestionsAPIResponse> => {
  try {
    const response = await axios.get(`/student/ifrs/${ifrsId}/questions`, {
      params: { page, limit, sort },
    });
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

